import React from 'react';
export function HeroSection() {
  return <div className="text-center mb-16" data-id="element-1043">
      <h1 className="text-4xl font-bold text-brand-dark mb-4" data-id="element-1044">
        Warranty & Returns
      </h1>
      <p className="text-xl text-gray-600" data-id="element-1045">
        Simple, transparent policies for professionals.
      </p>
    </div>;
}